/** Placeholder until portal return-request API is wired. */
export const PortalReturnRequestsPage = () => (
  <div className="p-4">
    <h1>Request a return</h1>
    <p>Self-service return requests are coming soon. Please email your account manager today.</p>
  </div>
);
